export enum UserRole {
  SEEKER = "seeker",
  PRACTITIONER = "practitioner",
}
